import { Button } from '@bambi/component-library/src/components/Button';
import { CoreFormFieldText } from '@bambi/component-library/src/components/forms/fields/CoreFormFieldText';
import { useCallback } from 'react';

import { clearFilters, hasFilters, setFilterSearch } from './payouts.slice';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { useDebouncedSearch } from 'src/common/useDebouncedSearch';

export function PayoutsScreenFilters() {
  const dispatch = useAppDispatch();
  const filterSearch = useAppSelector((state) => state.payouts.filterSearch);
  const anyFilters = useAppSelector(hasFilters);
  const { handleInputChange, inputValue } = useDebouncedSearch(
    setFilterSearch,
    filterSearch
  );
  const handleClearFilters = useCallback(() => {
    dispatch(clearFilters());
  }, [dispatch]);

  return (
    <div className="mt-1 flex flex-row gap-1">
      <CoreFormFieldText
        inputProps={{
          placeholder: 'Search payouts by invoice',
          style: {
            width: 225,
          },
          value: inputValue ?? '',
          onChange: (e) => {
            handleInputChange(e.target.value);
          },
        }}
      />
      {anyFilters ? (
        <Button variant="anchor" onClick={handleClearFilters}>
          clear filters
        </Button>
      ) : null}
    </div>
  );
}
